import { Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';

@Component({
    selector: 'app-editorikanconfig',
    templateUrl: './editorikanconfig.component.html',
    styleUrls: ['./editorikanconfig.component.scss'],
    standalone: false
})
export class EditOrikanConfigComponent extends ModelEditor implements OnInit {
  public modalService: SimpleModalService;

  constructor(
    private apiService: ApiServiceBase, 
    private injector: Injector, 
    modalService: SimpleModalService,
    private organizationsService: OrganizationsService
  ) {
    super("integrations/orikan/configuration", injector);
    this.modalService = modalService;
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      Description: "",
      BaseUrl: "https://",
      Username: "",
      Password: ""
    }
  }

  public override Validators(): any {
    return {
      BaseUrl: [Validators.maxLength(200), Validators.minLength(1), Validators.required],
      Name: [Validators.maxLength(40), Validators.minLength(1), Validators.required],
      Username: [Validators.maxLength(100)],
      Password: [Validators.maxLength(100)],
      Description: [Validators.maxLength(200)],
    }
  }

  public override AfterModelLoaded(): void {
    return;
  }
  
  public override BeforeSave(): boolean | void {
    return;
  }
}
